import { Alert, Dialog, Stack, TextField } from '@all-manager/design-system-v2';
import { Controller } from 'react-hook-form';
import { useNewSubTopicModal } from './useNewSubTopicModal';

type Props = {
  onClose: () => void;
  topicId: string;
  /** Called with the new sub-topic. Without it, the new sub-topic is opened. */
  onSuccess?: (subTopicId: string) => void;
};

export default function NewSubTopicModal(props: Props) {
  const hook = useNewSubTopicModal(props);

  return (
    <Dialog
      open
      onClose={hook.handleClose}
      onSubmit={hook.onSubmit}
      maxWidth="xs"
      fullWidth
      title="Nouveau sous-sujet"
      closeLabel="Fermer"
      actions={{
        primaryAction: {
          label: 'Créer',
          type: 'submit',
          loading: hook.isPending,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: hook.handleClose,
          disabled: hook.isPending,
        },
      }}
    >
      <Stack spacing={3}>
        {hook.serverError ? <Alert severity="error">{hook.serverError}</Alert> : null}

        <Controller
          name="name"
          control={hook.form.control}
          render={({ field, fieldState }) => (
            <TextField
              name={field.name}
              inputRef={field.ref}
              onBlur={field.onBlur}
              onChange={field.onChange}
              value={field.value}
              label="Nom du sous-sujet"
              placeholder="Ravalement de la façade…"
              autoFocus
              fullWidth
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />
      </Stack>
    </Dialog>
  );
}
